import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum ArrowBackIconVariant {
  DEFAULT = 'default',
}
export interface ICircleDeleteIconProps extends IConDefaultType {
  variant?: ArrowBackIconVariant;
}

export default function ArrowBackIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  style,
  variant = ArrowBackIconVariant.DEFAULT,
}: ICircleDeleteIconProps) {
  const _color = color ?? 'black';
  const _style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
    ...style,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={_style}>
      {variant === ArrowBackIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M13 4L7 10L13 16"
            stroke={_color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            x="50%"
            y="50%"
          />
        </svg>
      )}
    </i>
  );
}
